import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createPlatformApi } from '../utils/platformApi';
import { getOwnedSchoolIdForBilling } from '../utils/activeSchool';
import { formatDate } from '../utils/dateFormat';

const fmt = (n) => new Intl.NumberFormat('ru-RU').format(n);

const PAYMENT_STATUS = {
    succeeded: { color: '#27ae60' },
    pending: { color: '#f39c12' },
    canceled: { color: '#95a5a6' },
    failed: { color: '#c0392b' },
};

export default function PaymentHistoryModal({ open, onClose, preview = [] }) {
    const { t } = useTranslation(['platformBilling', 'common']);
    const [payments, setPayments] = useState(preview);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) load();
    }, [open]);

    async function load() {
        setLoading(true);
        try {
            const api = createPlatformApi();
            const schoolId = getOwnedSchoolIdForBilling();
            const res = await api.get('/platform/billing/history', {
                params: schoolId ? { schoolId } : {}
            });
            setPayments(res.data || []);
        } catch {
            setPayments(preview);
        }
        setLoading(false);
    }

    if (!open) return null;

    return (
        <div style={overlay} onClick={onClose}>
            <div style={modal} onClick={(e) => e.stopPropagation()}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0 }}>{t('platformBilling:paymentHistoryTitle')}</h3>
                    <button type="button" onClick={onClose} style={closeBtn}>×</button>
                </div>
                {loading ? (
                    <p style={{ marginTop: 16 }}>{t('platformBilling:loading')}</p>
                ) : payments.length === 0 ? (
                    <p style={{ marginTop: 16, color: '#888' }}>{t('platformBilling:noPaymentHistory')}</p>
                ) : (
                    <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse', marginTop: 12 }}>
                        <thead>
                            <tr style={{ textAlign: 'left', color: '#888' }}>
                                <th style={th}>{t('platformBilling:colPaymentDate')}</th>
                                <th style={th}>{t('platformBilling:colAmount')}</th>
                                <th style={th}>{t('platformBilling:colStatus')}</th>
                                <th style={th}>{t('platformBilling:colDescription')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payments.map((p) => {
                                const st = PAYMENT_STATUS[p.status] || PAYMENT_STATUS.pending;
                                const label = t(`platformBilling:paymentStatus_${p.status}`, { defaultValue: p.status });
                                return (
                                    <tr key={p.id} style={{ borderTop: '1px solid #eee' }}>
                                        <td style={td}>{formatDate(p.confirmedAt || p.createdAt)}</td>
                                        <td style={td}>{fmt(p.amount)} ₽</td>
                                        <td style={{ ...td, color: st.color, fontWeight: 600 }}>{label}</td>
                                        <td style={td}>{p.description || '—'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

const overlay = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
};
const modal = {
    background: '#fff', borderRadius: '16px', padding: '24px',
    maxWidth: '720px', width: '95%', maxHeight: '80vh', overflow: 'auto'
};
const closeBtn = { border: 'none', background: 'none', fontSize: '28px', cursor: 'pointer', lineHeight: 1 };
const th = { padding: '8px 4px' };
const td = { padding: '10px 4px' };
